import { VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { ResponsesStatementFixedIncomeResponse } from '@genial/services/dist/models';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { DetailsItem } from '../DetailsItem';
import { TableHead } from '../TableHead';

interface DetailsListProps {
  data: ResponsesStatementFixedIncomeResponse;
}

export const DetailsList: React.FC<DetailsListProps> = ({ data }) => {
  const viewportType = useBreakpointValue({ base: 'tablet', lg: 'desktop' });
  const isMobile = useBreakpointValue({ base: true, md: false });
  return (
    <VStack borderTopWidth={1} borderColor={'neutral.lightest'} space={Spacing['inline.xxxs']}>
      <VStack mt={Spacing['inline.xxxs']}>
        {!isMobile && <TableHead viewportType={viewportType} />}
        <DetailsItem data={data} />
      </VStack>
    </VStack>
  );
};
